<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Update Poster" @show="setUpdateData"  @hide="closeModal()">
    <div class="" v-if="show">
      <b-row>
        <b-col sm="5">
          <p-multiselect v-model="form.category" label="Select Category" name="category" :handler="$v" :formData="form" :options="categoryList" textKey="key" textValue="value" />
        </b-col>
        <b-col sm="4">
          <p-dropdown v-model="form.type" label="Device Type" name="type" :handler="$v" :formData="form" :options="deviceList" textKey="key" textValue="label"/>
        </b-col>
        <b-col sm="3">
          <p-input v-model="form.order" label="Order" name="order" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="6">
          <p-date-time v-model="form.daterange" label="Date Range" name="daterange" :handler="$v" :formData="form" :singleDatePicker="false"/>
        </b-col>
        <b-col sm="3">
          <p-switch v-model="form.auth_required" label="Authentication Required" name="auth_required" :handler="$v" :formData="form"/>
        </b-col>
        <b-col sm="3">
          <p-switch v-model="form.status" label="Status" name="status" :handler="$v" :formData="form"/>
        </b-col>
        <b-col sm="12">
          <p-radio v-model="form.actionType" label="Select Action" name="actionType" :handler="$v" :formData="form" :options="actionList" />
        </b-col>
        <template v-if="form.actionType !== 4">
          <b-col sm="12" v-if="[0,3].includes(form.actionType)">
            <p-input v-model="form.action" label="Url" name="action" :handler="$v" :formData="form" type="text" />
          </b-col>
          <b-col sm="12" v-if="form.actionType===2">
            <p-dropdown v-model="form.action" label="Select Promotion" name="action" :handler="$v" :formData="form" :options="promotionList" textKey="Name" textValue="Name"/>
          </b-col>
          <template v-if="form.actionType===1">
            <b-col sm="4">
              <p-dropdown v-model="form.brand" label="Select Platform" name="brand" :handler="$v" :formData="form" :options="brandList" textKey="Code" textValue="Name" @change="getGameList()"/>
            </b-col>
            <b-col sm="8">
              <p-dropdown v-model="form.game" label="Select Game" name="game" :loading="fetchingGames" :handler="$v" :formData="form" :options="gameList" textKey="GameId" textValue="GameName" />
            </b-col>
          </template>
        </template>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-tabs>
            <b-tab v-for="(value, index) in LANG" :key="index" :title="value.Name">
              <b-row>
                <b-col sm="6">
                  <p-image v-model="form.background[value.Lang]" label="Desktop Image" :checkKey="value.Lang" :name="`background`" :handler="$v" :formData="form" />
                </b-col>
                <b-col sm="6">
                  <p-image v-model="form.button[value.Lang]" label="Mobile image" name="button" :handler="$v" :formData="form" />
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </div>
    <b-button variant="success" @click="update()" :disabled="requesting">Update</b-button>
    <b-button variant="outline-danger" @click="closeModal()">Cancel</b-button>
  </b-modal>
</template>

<script>

import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required } from 'vuelidate/lib/validators'
import { PInput, PMultiselect, PDropdown, PDateTime, PRadio, PSwitch, PImage } from '../../../components'
const moment = require('moment-timezone')

export default {
  props: {
    showUpdateModal: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default: {}
    },
    promotionList: {
      type: Array,
      default: []
    },
    brandList: {
      type: Array,
      default: []
    },
    categoryList: {
      type: Array,
      default: []
    },
    deviceList: {
      type: Array,
      default: []
    },
    actionList: {
      type: Array,
      default: []
    }
  },
  data: () => {
    return {
      fetchingGames: false,
      gameList: [],
      requesting: false,
      created: false,
      form: {
        daterange: '',
        type: null,
        order: 1,
        category: '',
        actionType: 4,
        action: '',
        brand: '',
        game: null,
        auth_required: 0,
        status: 1,
        lang: [],
        background: [],
        button: [],
        errorMessages: {
          daterange: {
            required: 'Please select date range'
          },
          type: {
            required: 'Please select Device Type'
          },
          order: {
            required: 'Order is required'
          },
          category: {
            required: 'Please set category'
          },
          actionType: {
            required: 'Please select action type'
          },
          action: {
            checkRequired: 'Action is required'
          },
          brand: {
            checkRequired: 'Please select brand'
          },
          game: {
            checkRequired: 'Please select game'
          },
          auth_required: {
            required: 'Auth required must be set.'
          },
          status: {
            required: 'Status is required'
          },
          background: {
            required: 'Upload background image'
          },
          button: {
            required: 'Required'
          }
        }
      }
    }
  },
  validations: {
    form: {
      daterange: { required },
      type: { required },
      order: { required },
      category: { required },
      actionType: { required },
      action: {
        checkRequired () {
          return !([0, 3].includes(this.actionType) && this.form.action === '')
        }
      },
      brand: {
        checkRequired () {
          return !(this.actionType === 1 && this.form.brand === '')
        }
      },
      game: {
        checkRequired () {
          return !(this.actionType === 1 && this.form.game === '')
        }
      },
      auth_required: { required },
      background: {
        $each: {
          required
        }
      },
      button: {},
      status: { required }
    }
  },
  components: {
    PInput,
    PMultiselect,
    PDropdown,
    PDateTime,
    PRadio,
    PSwitch,
    PImage
  },
  computed: {
    show: {
      get: function () {
        return this.showUpdateModal
      },
      set: function () {
        return this.showUpdateModal
      }
    }
  },
  watch: {
    'form.actionType': function () {
      if (this.created) {
        this.form.action = (this.form.actionType === 2) ? null : ''
        this.form.brand = null
        this.form.game = null
      } else {
        this.created = true
      }
    }
  },
  methods: {
    async getGameList () {
      try {
        this.fetchingGames = true
        let { data } = await this.$http.get(this.API_ENDPOINT + `/game/gamelist?brand=${this.form.brand}`, { headers: { 'Content-Type': 'application/json' } })
        let game = data.list.map(x => { return { GameId: `${x.GameId}-${x.GameKindId}`, GameName: x.GameName } })
        this.gameList = game
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        this.fetchingGames = false
      }
    },
    async setUpdateData () {
      try {
        let game = this.updateData.Action.split('-')
        this.form.daterange = [moment(this.updateData.EnableDate).format('YYYY-MM-DD'), moment(this.updateData.DisableDate).format('YYYY-MM-DD')]
        this.form.type = this.updateData.Type
        this.form.order = this.updateData.Order
        this.form.category = this.updateData.Category.split(',').map(x => { return { key: x.trim(), value: x.trim() } })
        this.form.actionType = this.updateData.ActionType
        this.form.action = (this.updateData.Action === 1) ? '' : this.updateData.Action
        this.form.brand = game[2]
        this.form.game = `${game[0]}-${game[1]}`
        this.form.auth_required = this.updateData.Auth_required
        this.form.status = this.updateData.Status
        this.form.lang = this.form.Lang
        if (this.updateData.Background && this.updateData.Button && this.updateData.Background.length === this.updateData.Lang.length && this.updateData.Button.length === this.updateData.Lang.length) {
          this.updateData.Lang.forEach((val, index) => {
            this.form.background[val] = this.updateData.Background[index]
            this.form.button[val] = this.updateData.Button[index]
          })
        }

        await this.getGameList()
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async update () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }
        this.requesting = true
        let formData = new FormData()
        let category = this.form.category.reduce((prev, next) => { return prev + `${next.key}, ` }, '')
        category = category.slice(0, category.lastIndexOf(','))
        formData.append('category', category)
        formData.append('type', this.form.type)
        formData.append('order', this.form.order)
        formData.append('enableDate', this.form.daterange[0])
        formData.append('disableDate', this.form.daterange[1])
        formData.append('auth_required', this.form.auth_required)
        formData.append('status', this.form.status)
        formData.append('actionType', this.form.actionType)
        formData.append('action', (this.form.actionType === 1) ? `${this.form.game}-${this.form.brand}` : this.form.action)
        for (var key in this.LANGID) {
          formData.append('lang', key)
          formData.append('background', this.form.background[key] || '')
          formData.append('button', this.form.button[key] || '')
        }
        await this.$http.put(this.API_ENDPOINT + '/cms/poster/update/' + this.updateData.Id, formData, { headers: { 'Content-Type': 'application/json' } })

        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Poster Added Successfully')
        this.closeModal()
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        this.requesting = false
      }
    },
    closeModal () {
      this.$emit('cancelUpdate')
      this.$v.form.$reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/poster/Poster/UpdatePoster.vue